import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CurrencyProvider } from '../../utils/currencyContext/index';
import { WebPlanProvider } from '../../utils/webPlanContext/index';
import { EmailPlanProvider } from '../../utils/emailPlanContext/index';
import { CloudPlanProvider } from '../../utils/cloudPlanContext/index';
import Layout from '../layout';
import LanguageWrapper from '../languageWrapper';
import HomePage from '../../pages/home';
import BuildWebsitePage from '../../pages/buildWebsite';
import HostingWebPage from '../../pages/hostingWeb';
import HostingResellerPage from '../../pages/hostingReseller';
import DomainNamePage from '../../pages/domainName';
import EmailPage from '../../pages/email';
import VpsPage from '../../pages/vps';
import ContactPage from '../../pages/contact';
import AffiliateProgramPage from '../../pages/affiliateProgram';
import TermsPage from '../../pages/terms';

function Main() {
    const { i18n } = useTranslation();

    return (
        <CurrencyProvider>
            <WebPlanProvider>
                <EmailPlanProvider>
                    <CloudPlanProvider>
                        <Router>
                            <Routes>
                                <Route path="/:lang" element={<LanguageWrapper />}>
                                    <Route element={<Layout />}>
                                        <Route index element={<HomePage />} />
                                        <Route
                                            path="build-your-website"
                                            element={<BuildWebsitePage />}
                                        />
                                        <Route path="hosting/web" element={<HostingWebPage />} />
                                        <Route
                                            path="hosting/reseller"
                                            element={<HostingResellerPage />}
                                        />
                                        <Route path="domain-name" element={<DomainNamePage />} />
                                        <Route
                                            path="professional-business-email"
                                            element={<EmailPage />}
                                        />
                                        <Route path="vps-server" element={<VpsPage />} />
                                        <Route path="contact" element={<ContactPage />} />
                                        <Route
                                            path="affiliate-program"
                                            element={<AffiliateProgramPage />}
                                        />
                                        <Route path="terms" element={<TermsPage />} />
                                    </Route>
                                </Route>
                                <Route
                                    path="*"
                                    element={<Navigate to={`/${i18n.language}`} replace />}
                                />
                            </Routes>
                        </Router>
                    </CloudPlanProvider>
                </EmailPlanProvider>
            </WebPlanProvider>
        </CurrencyProvider>
    );
}

export default Main;
